import { logoutApp } from "global/context/action/auth/logoutApp";
import { useContext, useEffect } from "react";
import { useHistory } from "react-router";
import { guardarJsonConfig } from "../global/context/action/config/config";
import { GlobalContext } from "../global/context/Provider";
import Modal from "./components/Genericos/Modal/Modal";
import SegundoModal from "./components/Genericos/SegundoModal/SegundoModal";
import { resetDropdown } from "./context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal, showModal } from "./context/Actions/modal/modal";
import { logoutPaciente } from "./context/Actions/paciente/paciente";
import { tokenLogout } from "./context/Actions/token/logoutToken";
import { PortalContext } from "./context/Provider";
import { wsGetTextos } from "./context/Actions/textos/textos";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";

const GlobalInitializeData = ({ children }) => {
  const {
    tokenDispatch,
    modalState,
    segundoModalState,
    modalDispatch,
    pacienteDispatch,
    selectDropDownDispatch,
    textosState,
    textosDispatch,
  } = useContext(PortalContext);

  const history = useHistory();

  // Cambio de contexto
  const { authState, configDispatch, configState, authDispatch, toasterState } =
    useContext(GlobalContext);

  useEffect(() => {
    fetch(`./config.json?v=${new Date().getTime()}`)
      .then((response) => {
        return response.json();
      })
      .then((jsondata) => {
        guardarJsonConfig(jsondata)(configDispatch);
      });
  }, []);

  //Portal en Mantenimiento
  //--mantenimiento preventivo(por urgencia) si estas logueado te invita a salir
  const salirPortal = () => {
    // if (authState.authTraza.data !== null) {
    //   wsPostLogoutTraza(authState.authTraza.data.id, {
    //     ingreso: false,
    //     sector: configState.config.data.sectorTurno,
    //   })(authDispatch);
    // }
    logoutApp(history)(authDispatch);
    logoutPaciente(history)(pacienteDispatch);
    tokenLogout(history)(tokenDispatch);
    resetDropdown()(selectDropDownDispatch);
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("idApp");
    sessionStorage.token = "";
    sessionStorage.auth = "";
    hideModal()(modalDispatch);
  };

  // Use Effect de textos para evitar que se ejecute muchas veces
  useEffect(() => {
    if (!textosState.textos.data) {
      wsGetTextos()(textosDispatch);
    }
  }, []);

  useEffect(() => {
    if (configState.config.data) {
      if (configState.config.data.mantenimiento && authState.auth.data) {
        showModal(
          "Genericos/AvisoMantenimiento/AvisoMantenimiento",
          {},
          [
            {
              text: "Salir del Portal",
              clase: "btn bgc-primary rb16m c-white",
              // clase: "btn b-latex30 rb16m c-latex30",
              accion: salirPortal,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      }
    }
  }, [configState.config.data]);
  //-- fin portal mantenmiento urgencia

  return (
    <>
      {toasterState.toaster.show && <ToasterV2 />}
      {modalState.modal.show && <Modal />}
      {segundoModalState.segundoModal.show && <SegundoModal />}
      <div>{children}</div>
    </>
  );
};

export default GlobalInitializeData;
